export const visitWebsite = async (link: string | undefined) => {
  if (!link) return;
  if (isDESKTOP) {
    await window.electronAPI.openExternal(link);
  } else {
    window.open(link, "_blank");
  }
};
